export const theme = 'Sportscraft';
export const flattenedNavigation = false;
